import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/circle.pdf'; /*Change pdf*/
import { Helmet } from 'react-helmet';
import Mobile from '../images/circle.png'; /*Change image path*/

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {          /*Change left hand panel content*/
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>      
        Source:<br /><br />
		<var>Sämtliche Schriften und Briefe</var> series VII volume 6<br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp110-111<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: autumn 1674 - September 1676<br /><br />
		Translated from the Latin<br /><br />{isMobile ? '' : <hr className="centered-hr" />}
		<Link to={pdf} target="_blank">View this translation in PDF format (290k)</Link><br /><br />
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Arithmetic Quadrature of the Circle</title> {/*Change title*/}
            <meta name="description" content="An English translation of ARITHMETIC QUADRATURE OF THE CIRCLE by Gottfried Wilhelm Leibniz, from autumn 1674 - September 1676" />  {/*Change meta description*/}
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <td className="pdf-container">
                    <h2 className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ARITHMETIC QUADRATURE OF THE CIRCLE</h2> {/*Change title*/}
                    {isMobile ? renderLinks() : ''}
                    {isMobile ? <img src={Mobile} width="100%"/> : <embed src={pdf} className="responsive-embed"/>}
		              </td>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;